import { render, staticRenderFns } from "./data_collection_questions.vue?vue&type=template&id=a3c37dbe&"
import script from "./data_collection_questions.vue?vue&type=script&lang=js&"
export * from "./data_collection_questions.vue?vue&type=script&lang=js&"
import style0 from "./data_collection_questions.vue?vue&type=style&index=0&id=a3c37dbe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports